import React, { useEffect, useContext } from 'react';
import { Grid, Header, Icon, Container, Segment, Image, Message } from 'semantic-ui-react'
import { changePageName } from '../../../../myfunctions';
import pucharpatg1 from '../../../../assets/pucharpatg.png';
import useWindowDimensions from '../../../../hooks/useWindowDimensions';
import CallBackTG from '../../../../tools/CallBackTG';
import SupportPage from '../../../../tools/SupportPage/SupportPage';
import useAuth from '../../../../hooks/useAuth';
import AuthContext from '../../../../context/authContext';

function Contact() {
  const { width, height } = useWindowDimensions();// eslint-disable-line no-unused-vars
  const [auth, setAuth] = useAuth();// eslint-disable-line no-unused-vars
  const authContext = useContext(AuthContext);

  useEffect(() => {
    changePageName()
    return () => { }; // use effect cleanup to set flag false, if unmounted
  }, [])// eslint-disable-line react-hooks/exhaustive-deps


  return (


    <Container textAlign='center'  >

      <Segment raised style={{ marginTop: width < 700 ? 5 : 50, margin: "0 auto" }} >
        <Grid stackable >
          <Grid.Row verticalAlign='middle'  >
            <Grid.Column width={10}>

              <Header as='h3' icon>
                <Icon name='question circle' />
                Potrzebujesz Pomocy z Naszą Aplikacją?
                <Header.Subheader>
                  Hej, drogi użytkowniku!  – jesteśmy tutaj, aby pomóc!
                </Header.Subheader>
              </Header>
              <br /> <Icon name="question circle" />Znalazłeś/aś jakiś błąd w aplikacji, zgłoś go nam mailowo
              <br /> <Icon name="question circle" />Masz pomysł a może chcesz nawiązać współpracę, skontaktuj się z nami

              <Header as='h4'>Masz pytanie? Potrzebujesz wsparcia? A może szkolenia?</Header>
              <p>
                Nie wahaj się skontaktować z nami.<br />
                Jesteśmy gotowi odpowiedzieć na Twoje pytania oraz rozwiązać problemy.<br />
                Naszym celem jest zapewnienie Wam najlepszej jakości obsługi, więc nie krępuj się – pytaj śmiało!
              </p>
              <Header as='h4'>Potrzebujesz personalizacji rozgrywek?</Header>
              <p>
                Dla nas nie ma rzeczy niemożliwych, napisz do Nas!.
              </p>
              ZOBACZ: <span style={{fontWeight:"Bold",textDecoration:"underline",cursor:"pointer"}} onClick={() => authContext.changeModalInfo({ nameModal: "faq", name: "Często zadawane pytania", value: "" })}>Często zadawane pytania</span>


            </Grid.Column>
            <Grid.Column width={6} >



              <Image
                alt="puchartg"
                src={pucharpatg1}
                style={{ margin: "0 auto" }}

              />

            </Grid.Column>
          </Grid.Row>
        </Grid>
        <div style={{ marginTop: 50 }}>
          {auth ? <div style={{ textAlign: "left" }}><SupportPage /></div> : <div>
            <Message warning>
              Aby skontaktować się z nami, prosimy o wypełnienie formularza, który jest dostępny w tym miejscu lub zakładce MOJE KONTO - ZGŁOSZENIA/PYTANIA  po zalogowaniu.
              <br />Jeśli masz już konto, zaloguj się, aby uzyskać dostęp do formularza.
              <br />Jeśli jeszcze go nie posiadasz, możesz łatwo założyć konto całkowicie za darmo. Zapraszamy do rejestracji i kontaktu!
              <br />
              Lub tradycyjnie mailem <Icon name="mail" /><a href="mailto:biuro@turniej-generator.pl">biuro@turniej-generator.pl</a>

            </Message>
          </div>}

        </div>

      </Segment>


      <CallBackTG />

    </Container>

  )
}

export default Contact;